export default "__VITE_ASSET__WGgmHUc6__"